<script lang="ts">
  import { cartStore, cartTotal, cartTotalFormatted, cartItemCount } from '../stores/cart';
  import { formatCurrency } from '../utils/format';
  import CheckoutModal from './CheckoutModal.svelte';

  let showCheckout = $state(false);

  function removeItem(itemId: string) {
    cartStore.remove(itemId);
  }

  function updateQuantity(itemId: string, quantity: number) {
    cartStore.updateQuantity(itemId, quantity);
  }

  function openCheckout() {
    if ($cartStore.items.length > 0) {
      showCheckout = true;
    }
  }

  function closeCheckout() {
    showCheckout = false;
  }
</script>

<!-- Cart - Immer sichtbarer Bereich rechts (Registrierkasse) -->
<div class="fixed top-0 right-0 bottom-0 w-96 bg-white border-l border-gray-200 shadow-lg z-40 flex flex-col">
  <!-- Header -->
  <div class="p-4 border-b border-gray-200 bg-gray-50">
    <h2 class="text-lg font-bold text-gray-900">Warenkorb</h2>
  </div>
  
  <!-- Cart Items -->
  <div class="flex-1 overflow-y-auto p-4">
    {#if $cartStore.items.length === 0}
      <div class="text-center py-4">
        <p class="text-gray-600">Warenkorb ist leer</p>
      </div>
    {:else}
      <div class="space-y-2">
        {#each $cartStore.items as item}
          <div class="bg-gray-50 rounded-lg p-3">
            <!-- Header: Name und Remove -->
            <div class="flex items-start justify-between mb-2">
              <div class="flex-1 min-w-0 pr-2">
                <h3 class="font-semibold text-gray-900 text-sm truncate">{item.product.name}</h3>
                <div class="flex items-center space-x-2 mt-1">
                  <p class="text-xs text-gray-600">{formatCurrency(item.price)}</p>
                  {#if item.product.item_code}
                    <span class="text-xs text-gray-500">• {item.product.item_code}</span>
                  {/if}
                </div>
              </div>
              <!-- Remove Button -->
              <button
                onclick={() => removeItem(item.id)}
                class="text-red-500 hover:text-red-700 flex-shrink-0"
                aria-label="Entfernen"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </button>
            </div>
            
            <!-- Footer: Quantity und Subtotal -->
            <div class="flex items-center justify-between">
              <!-- Quantity Controls -->
              <div class="flex items-center space-x-2">
                <button
                  onclick={() => updateQuantity(item.id, item.quantity - 1)}
                  class="w-10 h-10 rounded-lg border-2 border-gray-300 bg-white hover:bg-gray-50 active:bg-gray-100 flex items-center justify-center text-lg font-bold text-gray-700 touch-manipulation flex-shrink-0"
                  aria-label="Menge reduzieren"
                >
                  -
                </button>
                <div class="w-14 px-2 py-1 bg-white rounded-lg border-2 border-gray-300 text-center flex-shrink-0">
                  <span class="text-base font-bold text-gray-900">{item.quantity}</span>
                </div>
                <button
                  onclick={() => updateQuantity(item.id, item.quantity + 1)}
                  class="w-10 h-10 rounded-lg border-2 border-gray-300 bg-white hover:bg-gray-50 active:bg-gray-100 flex items-center justify-center text-lg font-bold text-gray-700 touch-manipulation flex-shrink-0"
                  aria-label="Menge erhöhen"
                >
                  +
                </button>
              </div>
              
              <!-- Subtotal -->
              <span class="font-bold text-primary-600 text-base ml-auto">
                {formatCurrency(item.subtotal)}
              </span>
            </div>
          </div>
        {/each}
      </div>
    {/if}
  </div>

  <!-- Footer with Total and Checkout -->
  {#if $cartStore.items.length > 0}
    <div class="border-t border-gray-200 bg-gray-50 p-4">
      <div class="flex items-center justify-between mb-3">
        <div>
          <span class="text-sm text-gray-600">Artikel:</span>
          <span class="ml-2 font-medium text-gray-900">{$cartItemCount}</span>
        </div>
        <div class="text-right">
          <span class="text-sm text-gray-600">Gesamt:</span>
          <span class="ml-2 text-xl font-bold text-primary-600">{$cartTotalFormatted}</span>
        </div>
      </div>
      <button
        onclick={openCheckout}
        class="w-full bg-primary-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 touch-manipulation"
      >
        Zur Kasse
      </button>
    </div>
  {/if}

  <!-- Checkout Modal -->
  {#if showCheckout}
    <CheckoutModal total={$cartTotal} onClose={closeCheckout} />
  {/if}
</div>

